/**
 * Helper function to extract error message from validation errors
 * @param {Object} errorResponse - The error response object
 * @returns {string} - The first error message found
 */
const extractErrorMessage = (errorResponse) => {
    // Handle validation errors (400 status)
    if (errorResponse?.status === 400 && errorResponse?.errors) {
      const errors = errorResponse.errors;
      
      // Get the first error message from any field
      for (const field in errors) {
        if (errors[field] && errors[field].length > 0) {
          return errors[field][0]; // Return the first error message
        }
      }
    }
    // Default error message
    return  errorResponse.msg ||  'حدث خطأ غير متوقع';
  };
  
  export default extractErrorMessage;